import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IntegrationsMainComponent } from './containers/integrations-main/integrations-main.component';
import { IntegrationsRoutingModule } from './integrations-routing.module';
import { TranslateModule } from '@ngx-translate/core';
import { IntegrationsFiltersComponent } from './components/integrations-filters/integrations-filters.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SelectIntegrationEnabledComponent } from './components/select-integration-enabled/select-integration-enabled.component';
import { SelectIntegrationStatusComponent } from './components/select-integration-status/select-integration-status.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { SelectIntegrationPlatformsComponent } from './components/select-integration-platforms/select-integration-platforms.component';

@NgModule({
  declarations: [
    IntegrationsMainComponent,
    IntegrationsFiltersComponent,
    SelectIntegrationEnabledComponent,
    SelectIntegrationStatusComponent,
    SelectIntegrationPlatformsComponent
  ],
  imports: [
    NgbModule,
    CommonModule,
    IntegrationsRoutingModule,
    TranslateModule.forChild(),
    ReactiveFormsModule,
    FormsModule,
    SharedModule
  ]
})
export class IntegrationsModule { }
